<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                 disabled
                v-model="form.projectId"
                style="width: 100%"
                placeholder="项目名称"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"

                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="服务商名称" prop="name">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.name"
                placeholder="服务商名称"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>
          
          <el-col :span="8">
            <el-form-item label="服务商类型" prop="type">
              <el-select
                 :disabled="model==='view'" v-model="form.type"
                style="width: 100%"
                placeholder="服务商类型"
                @change="typeChange"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算周期" prop="billCycleNum">
              每
              <el-input-number
              style="width:3rem;"
                 :disabled="model==='view'" maxlength="6" v-model="form.billCycleNum" :controls="false" :min="1" :max="999999"></el-input-number>
              月
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可服务类型" prop="moduleTypes"> 
              
              <el-select
                 :disabled="model==='view'" v-model="form.moduleTypesIds"
                style="width: 100%"
                placeholder="可服务类型"
                @change="moduleTypesChange"
                multiple
              >
                <el-option
                  v-for="item in moduleTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="公司负责人" prop="contactName">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.contactName"
                placeholder="公司负责人"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.contactPhone"
                placeholder="联系电话"
                maxlength="11"
              ></el-input>  
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司地址" prop="address">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.address"
                placeholder="公司地址"
                maxlength="50"
              ></el-input>  
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                type="textarea"
                clearable
                :disabled="model==='view'" v-model="form.description"
                placeholder="备注"
                maxlength="300"
                show-word-limit
              ></el-input>  
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同附件" prop="contactPictureUrlList">
                <vUpload 
                 :disabled="model==='view'" :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多3张'" :types="['jpg','png']"  :max="5242880" :limit="9" :fileList.sync="form.contactPictureUrlList"></vUpload>
              </el-form-item>
            </el-col>
        </el-row>


        
        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="资质附件" prop="authPictureUrlList">
                <vUpload 
                 :disabled="model==='view'" :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多3张'" :types="['jpg','png']"  :max="5242880" :limit="9" :fileList.sync="form.authPictureUrlList"></vUpload>
              </el-form-item>
            </el-col>
        </el-row>


      </el-form>
    </div>
    <div style="text-align: right" v-if="model !== 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  saveProviderInfo,
  updateProviderInfo,
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband,
  getServiceProviderDetail
} from '../api/serveItemManage';
import vUpload from "../components/mutil-upload.vue"
export default {
  components: {vUpload},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      provideList: [
      ],
      form: {
        projectId:'',
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode:"",
        authPictureUrlList:[],
        contactPictureUrlList:[],
        moduleTypesIds:[],
        moduleTypes:'',
      },
      formRules: {
        projectId: [{ required: true, message: '项目名称不能为空', trigger: 'change' }],
        name: [{ required: true, message: '服务商名称不能为空', trigger: 'change' }],
        type: [{ required: true, message: '服务商类型不能为空', trigger: 'change' }],
        billCycleNum: [{ required: true, message: '结算周期不能为空', trigger: 'change' }],
        moduleTypes: [{ required: true, message: '可服务类型不能为空', trigger: 'change' }],
        contactName: [{ required: true, message: '公司负责人不能为空', trigger: 'change' }],
        contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      projectList:[],
      typeList:[],
      moduleTypeList:[],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    moduleTypesChange(){
      this.form.moduleTypes = '';
      if(this.form.moduleTypesIds&&this.form.moduleTypesIds.length>0){
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
    },
    userIdChange(val){
      let self = this;
      this.userList.forEach(ele=>{
        if(ele.id === val){
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      })
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
      console.log(this.form,this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
          console.log('getBasicInforDetail======================>');
      if(this.model === 'add'){
        this.form.projectId = this.row.projectId;
          console.log('getBasicInforDetail=====projectId=================>',this.row,this.form.projectId);
      }else{

        this.form = this._.cloneDeep(this.row);
        
        getServiceProviderDetail({id:this.row.id}).then(res=>{
          let self = this;
          this.form = res.data;
          this.form.moduleTypesIds = this.form.moduleTypes.split(',');
          this.form.contactPictureUrlList = [];
          this.form.authPictureUrlList = [];
          this.form.attachList.forEach(ele=>{
            if(ele.moduleType == 614 ){
              this.form.contactPictureUrlList.push(ele);
            }
            if(ele.moduleType == 615 ){
              this.form.authPictureUrlList.push(ele);
            }
          })
          this.form.type = this.form.type+'';
          this.form = this._.cloneDeep(self.form);
        });
      }
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      // getDictionary('nursinghome_payment_type').then((res) => {
      //   this.paymentTypeList = res.data;
      // });
      
      // getDictionary('nursinghome_release_mode_type').then((res) => {
      //   this.provideList = res.data;
      // });
      
      getDictionary('out_order_service_provider_type').then((res) => {
        this.typeList = res.data;
      });
      getDictionary('out_order_module_type').then((res) => {
        this.moduleTypeList = res.data;
      });
      
      if (this.model === 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
          this.matetialList = res.data;

          if (this.matetialList.length > 0) {
            this.form.consumableId = this.matetialList[0].id;
          }
        });
        //通过物料id获取仓库数据
        if (this.form.consumableId != '') {
          this.consumableIdChange();
        }
      } else {
      }
    },
    saveRecord() {
      if(this.form.moduleTypesIds&&this.form.moduleTypesIds.length>0){
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
      this.form.attachList = [];
      if(this.form.contactPictureUrlList&&this.form.contactPictureUrlList.length>0){

        let arrPic = [];
        this.form.contactPictureUrlList.forEach((ele)=>{
          arrPic.push({id:ele.id,moduleType: 614});
        })
        this.form.attachList = arrPic;
        }
      if(this.form.authPictureUrlList&&this.form.authPictureUrlList.length>0){

        let arrPic = [];
        this.form.authPictureUrlList.forEach((ele)=>{
          arrPic.push({id:ele.id,moduleType: 615});
        })
        this.form.attachList = this.form.attachList.concat(arrPic);
        }
      if ((this.model === 'add')) {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveProviderInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }else{
        
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateProviderInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  